/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/home/caHome',
	'react',
	'react-dom'
], function(caHome, React, ReactDOM) {

	const { Greeting } = caHome;
	class GreetingView {
		constructor(options) {
			this.glassContext = options.glassContext;
			this.containerNode = options.containerNode;
			this.itemSpec = options.itemSpec;
		}

		render() {
			ReactDOM.render(React.createElement(Greeting, {
				glassContext: this.glassContext,
				itemSpec: this.itemSpec
			}), this.containerNode);
		}

	}
	return GreetingView;
});